import { Toaster } from 'sonner';

// Sonner toaster config
export function SonnerProvider() {
  return (
    <Toaster
      position="top-right"
      expand={true}
      richColors={false}
      closeButton={true}
      toastOptions={{
        duration: 4000,
        classNames: {
          toast: 'bg-gray-900 border-gray-700 shadow-lg',
          title: 'text-white font-medium',
          description: 'text-gray-300',
          actionButton:
            'bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded-md text-sm font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-900',
          cancelButton:
            'bg-gray-700 hover:bg-gray-600 text-gray-300 px-3 py-1.5 rounded-md text-sm font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2 focus:ring-offset-gray-900',
          closeButton:
            'bg-gray-800 border-gray-600 text-gray-400 hover:text-white hover:bg-gray-700',
          success: 'bg-emerald-900 border-emerald-700 text-emerald-100',
          error: 'bg-red-900 border-red-700 text-red-100',
          warning: 'bg-amber-900 border-amber-700 text-amber-100',
          info: 'bg-blue-900 border-blue-700 text-blue-100',
        },
        style: {
          background: 'rgb(17 24 39)', // gray-900
          color: 'white',
          border: '1px solid rgb(55 65 81)', // gray-700
          fontSize: '14px',
        },
      }}
    />
  );
}
